import Icon from '../components/Icon.vue'

Icon.register({
  'comment-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M64 240c0-18.6 3.3-36.5 8.9-53.6l325.5 251.6c-24.7 6.4-51 10-78.4 10-38.4 0-74.7-7.1-107.4-19.4-24.6 19.6-74.3 51.4-140.6 51.4-3.2 0-6-1.9-7.3-4.8-1.3-3-0.7-6.4 1.5-8.7 0.5-0.6 42.2-45.5 54.8-95.8-35.6-35.7-57-81.1-57-130.7zM633.8 458.1c7 5.4 8.3 15.5 2.9 22.3l-19.6 25.3c-5.5 7-15.5 8.2-22.5 2.8l-588.4-454.7c-7-5.4-8.2-15.4-2.8-22.4l19.6-25.2c5.5-7 15.5-8.2 22.5-2.8l105.1 81.3c45.2-32.6 104.3-52.7 169.4-52.7 141.4 0 256 93.1 256 208 0 49.2-21.4 94.1-56.6 129.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-slash.js
// module id = 1230
// module chunks = 0